import { render, staticRenderFns } from "./RoleNew.vue?vue&type=template&id=a77b0e04"
import script from "./RoleNew.vue?vue&type=script&lang=js"
export * from "./RoleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports